export const LOGIN_CALLBACK_PATH = '/login_callback';
export const LOGOUT_PATH = '/logout';
